import React from 'react';
import { Button, Modal, ModalHeader } from 'reactstrap';
import IntlMessages from 'util/IntlMessages';
import FormErrors from 'components/formErrors/FormErrors';
import { isEmailValid, isNameValid } from 'services/Validation';
import { isAdmin } from 'services/Authentication';

class AddEmp extends React.Component {
    constructor(props) {
        super(props);

        const { id, orgid, thumb, name, email, phone, designation, selected, starred, frequently, role } = props.employee;
        this.state = {
            id,
            orgid,
            thumb,
            name,
            email,
            phone,
            designation,
            selected,
            starred,
            frequently,
            role,
            checked: role === 'gold',
            nameValid: isNameValid(name),
            emailValid: isEmailValid(email),
            formErrors: { name: '', email: '' },
            formValid: false
        };
    }

    componentDidMount() {
        this.validateForm();
    }

    handleUserInput = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        this.setState(
            { [name]: value },
            () => { this.validateField(name, value); } // run this call back on state change
        );
    }

    handleRoleChange = () => {
        // toggle the checked prop
        this.setState({checked: !this.state.checked});
    };

    validateField(fieldName, value) {
        let fieldValidationErrors = this.state.formErrors;
        let nameValid = this.state.nameValid;
        let emailValid = this.state.emailValid;

        switch (fieldName) {
            case 'name':
                nameValid = isNameValid(value);
                fieldValidationErrors.name = nameValid ? '' : ' is invalid';
                break;
            case 'email':
                emailValid = isEmailValid(value);
                fieldValidationErrors.email = emailValid ? '' : ' is invalid';
                break;
            default:
                break;
        }
        this.setState({
            formErrors: fieldValidationErrors,
            nameValid: nameValid,
            emailValid: emailValid,
        }, this.validateForm);
    }

    validateForm() {
        this.setState({ formValid: this.state.nameValid && this.state.emailValid });
    }

    render() {
        const { onSaveEmp, showEmpLoader, onEmpClose, open, employee } = this.props;
        const { id, orgid, name, email, phone, designation, selected, starred, frequently, checked } = this.state;
        const isNew = employee.name === '';
        let { thumb } = this.state;
        return (
            <Modal className="modal-box" toggle={onEmpClose} isOpen={open}>
                <ModalHeader className="modal-box-header bg-primary">
                    {isNew ? <IntlMessages id="emp.addEmp" /> :
                        <IntlMessages id="emp.saveEmp" />}
                    <span className="text-white pointer">
                        <i className="zmdi zmdi-close zmdi-hc-lg" onClick={onEmpClose} />
                    </span>
                </ModalHeader>

                <div className="modal-box-content">
                    <div className="row no-gutters">
                        <div className="col-lg-3 text-center text-lg-right order-lg-2">
                            <img className="ml-lg-3 mb-4 mb-lg-0 avatar size-120" src={thumb} />
                        </div>

                        <div className="panel panel-default">
                            <FormErrors formErrors={this.state.formErrors} />
                        </div>

                        <div className="col-lg-9 d-flex flex-column order-lg-1">
                            <h3 className="card-heading">{<IntlMessages id="label.name" />}</h3>
                            <input type="text" className={`form-control mb-2 ${name ? 'is-valid' : 'is-invalid'}`}
                                onChange={(event) => this.handleUserInput(event)}
                                defaultValue={name} name="name"
                            />
                            <h3 className="card-heading">{<IntlMessages id="label.email" />}</h3>
                            <input type="text" className={`form-control mb-2 ${email ? 'is-valid' : 'is-invalid'}`}
                                onChange={(event) => this.handleUserInput(event)}
                                value={email} name="email"
                            />
                            <h3 className="card-heading">{<IntlMessages id="label.phone" />}</h3>
                            <input type="text" className="form-control mb-2"
                                placeholder="Employee Phone"
                                onChange={(event) => this.setState({ phone: event.target.value })}
                                value={phone} name="phone"
                            />
                            <h3 className="card-heading">{<IntlMessages id="label.department" />}</h3>
                            <input type="text" className="form-control mb-2"
                                onChange={(event) => this.setState({ designation: event.target.value })}
                                value={designation} name="designation"
                            />
                            { isAdmin ? 
                                <div className="custom-control custom-checkbox my-1 mr-sm-2">
                                    <input type="checkbox" className="custom-control-input" id="adminCheckbox1"
                                        defaultChecked={checked} onChange={this.handleRoleChange} />
                                    <label className="custom-control-label" htmlFor="adminCheckbox1">Administrator access</label>
                                </div>
                                : null
                            }
                        </div>
                    </div>
                </div>

                <div className="modal-box-footer d-flex flex-row">
                    <Button className="text-uppercase" disabled={!this.state.formValid} color="primary" onClick={() => {
                        showEmpLoader();
                        onEmpClose();
                        onSaveEmp(
                            {
                                'id': id,
                                'orgid': orgid,
                                'name': name,
                                'thumb': null,
                                'email': email,
                                'phone': phone,
                                'designation': designation,
                                'selected': selected,
                                'starred': starred,
                                'frequently': frequently,
                                'role': checked ? 'gold' : 'silver',
                            });
                        this.setState({
                            id: '',
                            orgid: '',
                            name: '',
                            thumb: null,
                            email: '',
                            phone: '',
                            designation: '',
                            selected: false,
                            starred: false,
                            frequently: false,
                            role: '',
                            formErrors: { name: '', email: '' },
                            formValid: false
                        });
                    }}>
                        {isNew ? <IntlMessages id="emp.addEmp" /> :
                            <IntlMessages id="emp.saveEmp" />}</Button>
                </div>
            </Modal>
        );
    }
}

export default AddEmp;


// WEBPACK FOOTER //
// ./components/Agile/Employee/AddEmp/index.js